import { render, staticRenderFns } from "./DetailFilterFields.vue?vue&type=template&id=2397115f&"
import script from "./DetailFilterFields.vue?vue&type=script&lang=js&"
export * from "./DetailFilterFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports